import EpgDataManager from '../../AAFPersistenceManager/EpgDataManager';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import LoadFav from '../LoaderExp/LoadFav';
import channelStreamUtil from '../../utils/ChannelStreamUtil';
import EpgConstants from './EpgConstants';
import logger from 'src/utils/logger/logger';

/**
 * @method getGroupIdsEventsByTimeWindow return an array, where each element is an events array of group id
 * @param {Array} groupIds group ids array to search events
 * @param {number} startTime start time to filter events
 * @param {number} endTime end time to filter events
 */
const getGroupIdsEventsByTimeWindow = function(
  groupIds = [],
  startTime = 0,
  endTime = 0,
  cb = null
) {
  return new EpgDataManager().getGroupIdsEventsByTimeWindow(groupIds, startTime, endTime, cb);
};
/**
 * @method getChannelByGroupId return an channel object filter by groupid
 * @param {string} groupId group id associated with a channel
 */
const getChannelByGroupId = async function(groupId) {
  return await new EpgDataManager().getChannelByGroupId(groupId);
};
/**
 * @method getEventByEventId return an event object filter by eventId
 * @param {string} eventId event id associated with a channel
 */
const getEventByEventId = async function(id_composite, eventId, groupId = null) {
  return await new EpgDataManager().selectEvents(id_composite, eventId, groupId);
};
/**
 * @method getCurrentEventByGroupId return the current event object filter by groupId
 * @param {string} group_id event id associated with a channel
 */
const getCurrentEventByGroupId = async function(group_id) {
  return await new EpgDataManager().getCurrentEventByGroupId(group_id);
};
/**
 * @method getNextEventByEvent return the next event object filter by event
 * @param {object} event event associated with a channel
 */
const getNextEventByEvent = async function(event) {
  return await new EpgDataManager().getNextEventByEvent(event);
};
/**
 * @method getPreviousEventByEvent return the previous event object filter by event
 * @param {object} event event associated with a channel
 */
const getPreviousEventByEvent = async function(event) {
  return await new EpgDataManager().getPreviousEventByEvent(event);
};
/**
 * @method getPreviousCurrentNextEventByGroupId return the previous, current and next event object filter by groupId
 * @param {string} group_id event id associated with a channel
 */
const getPreviousCurrentNextEventByGroupId = async function(group_id) {
  return await new EpgDataManager().getPreviousCurrentNextEventByGroupId(group_id);
};
/**
 * @method updateRecordings update recordings: recording status and recording id of specific event
 * @param {Array} recordings array of object with this structure {group_id, event_id, recording_status, recording_id}
 */
const updateRecordings = function(recordings) {
  return new EpgDataManager().updateRecordings(recordings);
};
/**
 * @method getFilters return an filters array
 */
const getFilters = function() {
  return new ChannelSingleton().getFilters();
};
/**
 * @method getChannels return an all channels array
 */
const getChannels = function() {
  return new ChannelSingleton().getChannels();
};

const getEventByGroupIdByStartTime = async function(group_id, startTime) {
  return await new EpgDataManager().getEventByGroupIdByStartTime(group_id, startTime);
};

const getChannelsByFilterId = async function(node) {
  let channel = [];
  if(node && node.id && node.id === EpgConstants.FAV_ID_ITEM){
    const channels = LoadFav.getAllFavs();
    if(Array.isArray(channels)){
      for(const x in channels){
        const groupID = channels[x];
        const channelget =  channelStreamUtil.get(groupID);
        if(channelget){
          channel.push(channelget);
        }
      }
    }
  }else{
    channel = new ChannelSingleton().getFilteredChannelsByNode(node.id);
  }
  return new Promise(resolve => resolve(channel));
};

/**
 GridRowItem.prototype._updateSize = function (startTime, endTime) {
		var windowStartTime = this._dataMapper.getWindowStartTime(),
			windowEndTime = windowStartTime + $N.app.constants.GRID_TIME_WINDOW,
			itemStart = Math.max(startTime, windowStartTime),
			itemEnd = Math.min(endTime, windowEndTime),
			itemDuration = itemEnd - itemStart,
			itemWidth = itemDuration * (this._gridWidth / $N.app.constants.GRID_TIME_WINDOW);

		this._isWideEnoughForTitle = itemDuration >= this._MIN_TEXT_WIDTH;
		this._isWideEnoughForSubtitle = itemDuration > this._MIN_TEXT_WIDTH;
		this._isWideEnoughForIcons = itemDuration >= this._MIN_ICON_WIDTH;

		if (itemDuration === this._MIN_ICON_WIDTH) {
			this._isWideEnoughOnlyForTwoIcons = true;
		} else {
			this._isWideEnoughOnlyForTwoIcons = false;
		}
		if (itemEnd !== windowEndTime) {
			itemWidth = itemWidth - this.PADDING;
		}
		this.setWidth(itemWidth);
	};

 */

/**
 *
 * @param {*} eventStartTime
 * @param {*} eventEndTime
 * @param {*} timeWindowStart
 * @param {*} timeWindowLength
 * @param {*} eventGridWidth
 */
const getEventGridWidth = function(
  eventStartTime,
  eventEndTime,
  timeWindowStart,
  timeWindowLength,
  eventGridWidth,
  spaceBetweenEvents
) {
  // Base resolution is 1280 * 720 px
  let factor = 1000;
  let width = eventGridWidth; // Default a 1280
  try {
    timeWindowStart = timeWindowStart * factor;
    let timeWindowEnd = timeWindowStart + timeWindowLength;
    eventStartTime = eventStartTime * factor;
    eventEndTime = eventEndTime * factor;

    let eventStartIn = Math.max(eventStartTime, timeWindowStart);
    let eventEndIn = Math.min(eventEndTime, timeWindowEnd);
    let eventDuration = eventEndIn - eventStartIn;
    width = eventDuration * (eventGridWidth / timeWindowLength);

    if (eventEndIn !== timeWindowEnd) {
      width = width - spaceBetweenEvents;
    }
  } catch (err) {
    logger.error('[NEPG] EPGUtil.getEventGridWidth error', err);
  }

  return width;
};

const isValidEvent = function(event) {
  return (
    typeof event.date_begin != 'undefined' &&
    typeof event.date_begin != 'undefined' &&
    typeof event.group_id != 'undefined'
  );
};

const isFullEvent = function(event) {
  return new EpgDataManager().isFullEvent(event);
};

/**
 * Regresa TRUE si se hacen las animaciones de los eventos con requestAnimationFrame (PAU)
 * Regresa FALSE si se hacen las animaciones de los eventos con CSS (Jony)
 */
const enableNativeAnimation = function() {
  // Default las de Jony
  return false;
};

/**
 * @module EPG : to get all information needed to display a EPG.
 */
const EPGUtil = {
  getGroupIdsEventsByTimeWindow: getGroupIdsEventsByTimeWindow,
  getEventByEventId: getEventByEventId,
  getCurrentEventByGroupId: getCurrentEventByGroupId,
  getNextEventByEvent: getNextEventByEvent,
  getPreviousEventByEvent: getPreviousEventByEvent,
  getPreviousCurrentNextEventByGroupId: getPreviousCurrentNextEventByGroupId,
  getEventByGroupIdByStartTime: getEventByGroupIdByStartTime,
  getChannelsByFilterId: getChannelsByFilterId,
  // Tools/helpers
  getEventGridWidth: getEventGridWidth,
  isValidEvent: isValidEvent,
  isFullEvent: isFullEvent,
  updateRecordings: updateRecordings,
  enableNativeAnimation: enableNativeAnimation
};

export { EPGUtil };



// WEBPACK FOOTER //
// ./src/AAF/Nepg/EPGUtil.js